import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setEnergyGrid = (state, { energyGrid }) => {
  if (!energyGrid) return state;
  return state.merge({ energyGrid });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_ENERGY_GRID,
    actionFunction: setEnergyGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
